(function () {
  'use strict';

  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  function init(picker) {
    var formId = picker.dataset.formId;
    var hiddenInput = document.getElementById('maly-color-input-' + formId);
    var labelSelected = picker.querySelector('.maly-swatch-label__selected');
    var buttons = picker.querySelectorAll('.maly-swatch-btn');

    // Desktop : tooltip ancré au swatch survolé
    var preview = document.getElementById('maly-swatch-preview-' + formId);
    var previewImg = preview && preview.querySelector('.maly-swatch-preview__img');
    var previewName = preview && preview.querySelector('.maly-swatch-preview__name');
    var previewFinish = preview && preview.querySelector('.maly-swatch-preview__finish');
    var hoverTimer = null;
    var confirmedColorName = ''; // couleur fixée par le dernier clic

    // Mobile : aperçu inline sous les swatches
    var inlinePreview = document.getElementById('maly-inline-preview-' + formId);
    var inlineImg = inlinePreview && inlinePreview.querySelector('.maly-swatch-inline-preview__img');
    var inlineName = inlinePreview && inlinePreview.querySelector('.maly-swatch-inline-preview__name');
    var inlineFinish = inlinePreview && inlinePreview.querySelector('.maly-swatch-inline-preview__finish');

    buttons.forEach(function (btn) {
      // Sélection au clic (desktop + mobile)
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');

        confirmedColorName = btn.dataset.colorName;
        if (hiddenInput) hiddenInput.value = confirmedColorName;
        if (labelSelected) labelSelected.textContent = ' ' + confirmedColorName;
        updateArisField(confirmedColorName);

        // Mobile : aperçu inline sous les swatches, se ferme seul après 3s
        if (isMobile) openInlinePreview(btn);
      });

      // Desktop : prévisualisation du nom + aperçu photo au survol
      if (!isMobile) {
        btn.addEventListener('mouseenter', function () {
          if (labelSelected) labelSelected.textContent = ' ' + btn.dataset.colorName;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () {
            openDesktopPreview(btn);
          }, 250);
        });
        btn.addEventListener('mouseleave', function () {
          clearTimeout(hoverTimer);
          closeDesktopPreview();
          // Restaurer le nom confirmé (ou vide si rien encore sélectionné)
          if (labelSelected) labelSelected.textContent = confirmedColorName ? ' ' + confirmedColorName : '';
        });
      }
    });

    // Fermeture desktop aussi sur Échap
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDesktopPreview();
    });

    function openDesktopPreview(btn) {
      if (!preview) return;
      if (previewImg) { previewImg.src = btn.dataset.photoEntiere; previewImg.alt = btn.dataset.colorName; }
      if (previewName) previewName.textContent = btn.dataset.colorName;
      if (previewFinish) previewFinish.textContent = formatFinish(btn.dataset.finition);
      preview.classList.add('is-visible');
      positionDesktopPreview(btn);
    }

    function closeDesktopPreview() {
      if (preview) preview.classList.remove('is-visible');
    }

    // Ancre le tooltip au swatch survolé : position calculée relativement à
    // .maly-swatch-picker (le containing block de .maly-swatch-preview),
    // indépendamment de l'ordre des blocs de la section produit.
    function positionDesktopPreview(btn) {
      var gap = 10;
      var pickerRect = picker.getBoundingClientRect();
      var btnRect = btn.getBoundingClientRect();
      var previewWidth = preview.offsetWidth;
      var previewHeight = preview.offsetHeight;

      var left = (btnRect.left - pickerRect.left) + (btnRect.width / 2) - (previewWidth / 2);
      var maxLeft = Math.max(0, picker.offsetWidth - previewWidth);
      left = Math.min(Math.max(left, 0), maxLeft);

      var top;
      if (btnRect.top - previewHeight - gap > 0) {
        // assez de place au-dessus du swatch (cas courant)
        top = (btnRect.top - pickerRect.top) - previewHeight - gap;
      } else {
        // swatch trop proche du haut du viewport : afficher en dessous
        top = (btnRect.bottom - pickerRect.top) + gap;
      }

      preview.style.left = left + 'px';
      preview.style.top = top + 'px';
    }

    function openInlinePreview(btn) {
      if (!inlinePreview) return;
      if (inlineImg) { inlineImg.src = btn.dataset.photoEntiere; inlineImg.alt = btn.dataset.colorName; }
      if (inlineName) inlineName.textContent = btn.dataset.colorName;
      if (inlineFinish) inlineFinish.textContent = formatFinish(btn.dataset.finition);
      inlinePreview.style.display = 'flex';
      clearTimeout(inlinePreview._autoClose);
      inlinePreview._autoClose = setTimeout(function () {
        inlinePreview.style.display = 'none';
      }, 3000);
    }
  }

  function formatFinish(finition) {
    return finition ? finition.replace(/-/g, ' ') : '';
  }

  function updateArisField(colorName) {
    var inputs = document.querySelectorAll(
      'input[name="properties[Couleur principale]"]:not([id^="maly-"]), ' +
      'select[name="properties[Couleur principale]"]'
    );
    inputs.forEach(function (input) {
      if (input.tagName === 'SELECT') {
        var opt = Array.from(input.options).find(function (o) { return o.value === colorName; });
        if (opt) input.value = colorName;
      } else {
        input.value = colorName;
      }
    });
  }

  // Masquer le bloc Aris "Couleur principale"
  //
  // Important : Aris réutilise le même composant ("nuancier d'image") et donc les
  // mêmes classes (avp-productoptionswatchwrapper / apo-swatch-wrapper) pour
  // d'autres options sans rapport sur certains produits (ex. "Couleur du tissu"
  // sur les cadres filaires). Cibler ces classes sur toute la page masquait aussi
  // ces champs, qui restaient "required" côté Aris mais invisibles pour le client
  // — bloquant silencieusement l'ajout au panier. On identifie donc uniquement le
  // champ "Couleur principale" par son name, puis on ne remonte dans ses ancêtres
  // que tant qu'aucun AUTRE champ properties[...] n'est trouvé dans le sous-arbre.
  function hideArisColorField() {
    var hiddenSet = new Set();

    function hide(el) {
      if (!el || hiddenSet.has(el)) return;
      el.style.setProperty('display', 'none', 'important');
      if (el.tagName === 'INPUT' || el.tagName === 'SELECT' || el.tagName === 'TEXTAREA') {
        el.disabled = true;
      }
      hiddenSet.add(el);
    }

    function findOwnContainer(field) {
      var container = field;
      var current = field.parentElement;
      while (current && current !== document.body && !current.closest('.maly-swatch-picker')) {
        var otherFields = Array.prototype.filter.call(
          current.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]'),
          function (el) { return el !== field; }
        );
        if (otherFields.length > 0) break;
        container = current;
        current = current.parentElement;
      }
      return container;
    }

    document.querySelectorAll(
      'input[name="properties[Couleur principale]"]:not([id^="maly-"]), ' +
      'select[name="properties[Couleur principale]"], ' +
      'textarea[name="properties[Couleur principale]"]'
    ).forEach(function (field) {
      if (field.closest('.maly-swatch-picker')) return;
      hide(field);
      hide(findOwnContainer(field));
    });
  }

  function watchForAris() {
    hideArisColorField();
    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          if (n.nodeType !== 1) return false;
          return n.matches('.avp-productoptionswatchwrapper, .apo-swatch-wrapper, [name="properties[Couleur principale]"]') ||
                 n.querySelector('.avp-productoptionswatchwrapper, .apo-swatch-wrapper, [name="properties[Couleur principale]"]');
        });
      });
      if (relevant) hideArisColorField();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  document.querySelectorAll('[data-maly-swatch-picker]').forEach(init);
  watchForAris();
})();
